<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Dso1UT/tc-custom/9781611520385.jpg?1723406474069" alt="This image is the cover for the book Fire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fire
      </h1>
      <p class="bookDescription body article font2">
        <p>Richter and Tanner meet again! Tanner has a hard time staying in the straight life and out of the street life, and ex-cop Sandy watches his friend with both sadness and lust. When a fire in Sandy's nature park rages out of control, Tanner has to step up and give more of himself than he anticipated.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vincent Diamond
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6b90927a